<template>
  <div>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          有害物質管理
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <v-row>
      <v-col class="text-right">
        <v-btn
          color="info"
          @click="addButtonClickEvent"
        >
          追加する
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="hazardous_substances"
              disable-sort
              hide-default-footer
            >
              <template v-slot:[`item.created_at`]="{ item }">
                {{ item.created_at | unix_datetime_format }}
              </template>
              <template v-slot:[`item.updated_at`]="{ item }">
                {{ item.updated_at | unix_datetime_format }}
              </template>
              <template v-slot:[`item.editable`]="{ item }">
                <v-btn
                  v-if="$vuetify.breakpoint.mdAndUp"
                  icon
                  color="cyan darken-2"
                  @click="showButtonClickEvent(item)"
                >
                  <v-icon>mdi-file-document-outline</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="cyan"
                  @click="showButtonClickEvent(item)"
                >
                  参照する
                </v-btn>
                <v-btn
                  v-if="$vuetify.breakpoint.mdAndUp"
                  color="cyan darken-2"
                  icon
                  @click="editButtonClickEvent(item)"
                >
                  <v-icon>mdi-note-edit</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="cyan"
                  @click="editButtonClickEvent(item)"
                >
                  編集する
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row dense>
      <v-col>
        <v-pagination
          v-model="current_page"
          :length="10"
          circle
          :total-visible="5"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->
  </div>
</template>

<script>
export default {
  name: 'AdminMasterHazardousSubStanceIndex',
  components: {},
  mixins: [],
  data () {
    return {
      current_page: 1,
      tableHeaders: [
        { value: 'code', text: 'コード' },
        { value: 'name', text: '名称' },
        { value: 'created_at', text: 'データ作成日時' },
        { value: 'updated_at', text: 'データ更新日時' },
        { value: 'position', text: '表示順', align: 'right' },
        { value: 'editable', text: '', align: 'end' }
      ],
      hazardous_substances: [
        {
          id: 1,
          code: '01',
          name: '水銀又はその化合物',
          position: 1,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 2,
          code: '02',
          name: 'カドミウム又はその化合物',
          position: 2,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 3,
          code: '03',
          name: '鉛又はその化合物',
          position: 3,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 4,
          code: '04',
          name: '有機燐化合物',
          position: 4,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 5,
          code: '05',
          name: '六価クロム化合物',
          position: 5,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 6,
          code: '06',
          name: '砒素又はその化合物',
          position: 6,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 7,
          code: '07',
          name: 'シアン化合物',
          position: 7,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 8,
          code: '08',
          name: 'ＰＣＢ',
          position: 8,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 9,
          code: '09',
          name: 'トリクロロエチレン',
          position: 9,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
        {
          id: 10,
          code: '10',
          name: 'テトラクロロエチレン',
          position: 10,
          created_at: 1633314402,
          updated_at: 1633314402,
        },
      ]
    }
  },
  created() {
  },
  methods: {
    addButtonClickEvent () {
      this.$router.push({name: 'AdminMasterHazardousSubStanceNew'})
    },
    showButtonClickEvent (item) {
      this.$router.push({name: 'AdminMasterHazardousSubStance', params: {id: item.id}})
    },
    editButtonClickEvent (item) {
      this.$router.push({name: 'AdminMasterHazardousSubStanceEdit', params: {id: item.id}})
    }
  }
}
</script>

<style scoped>

</style>
